/** The state of a list or a record before it arrives, or when it is empty. */
export default function Message({ children }: { children: React.ReactNode }) {
    return (
        <div className="rounded-card border border-line bg-card px-5 py-10 text-center text-[13px] text-fg-muted shadow-card">
            {children}
        </div>
    );
}
